(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle)) return;
  if (window.__smoofDesignFileV228) return;
  window.__smoofDesignFileV228 = true;
  window.__smoofDesignFileV227 = true;
  window.__smoofDesignFileV226 = true;

  const FORMAT = 'SMOOF_DESIGN';
  const VERSION = 2;
  const SUPPORTED_VERSIONS = new Set([1, 2]);
  const MAX_FILE_BYTES = 50 * 1024 * 1024;
  const FONT_OPTION_ID = '052c068b-772b-4d04-af0d-56214e55cce3';
  const PRODUCT_OPTION_INDEXES = new Set(['1', '2', '3']);
  const PRODUCT_CONFIGURATION_PROPERTIES = new Set([
    'properties[_SMOOF NFC]',
    'properties[_SMOOF Druckformat mm]',
    'properties[_SMOOF Holzart]',
    'properties[_SMOOF Variant ID]',
    'properties[_SMOOF Variant Schema]'
  ]);
  const IMAGE_DATA_URL = /^data:image\/(?:png|jpe?g|webp|gif|svg\+xml)(?:;[^,]*)?,/i;
  const root = document.documentElement;
  const t = (de, en) => root.lang.toLowerCase().startsWith('en') ? en : de;
  let picker = null;
  let statusTimer = 0;

  function productForm() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]')) || null;
  }

  function showStatus(message, error = false) {
    let status = document.querySelector('[data-smoof-design-file-status]');
    if (!status) {
      status = document.createElement('div');
      status.dataset.smoofDesignFileStatus = 'true';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      document.body.appendChild(status);
    }
    clearTimeout(statusTimer);
    status.textContent = message;
    status.dataset.error = String(error);
    status.dataset.visible = 'true';
    statusTimer = setTimeout(() => { status.dataset.visible = 'false'; }, 3200);
  }

  function nativeValue(control, value) {
    if (!control) return;
    if (control instanceof HTMLInputElement && control.type === 'file') {
      if (String(value ?? '') === '') control.value = '';
      return;
    }
    const prototype = control instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : control instanceof HTMLTextAreaElement
        ? HTMLTextAreaElement.prototype
        : HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor?.set) descriptor.set.call(control, value);
    else control.value = value;
  }

  function nativeChecked(control, checked) {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
    if (descriptor?.set) descriptor.set.call(control, checked);
    else control.checked = checked;
  }

  function notifyControl(control) {
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function editableControls(container) {
    return Array.from(container.querySelectorAll('input, select, textarea'))
      .filter(control =>
        control.closest('[data-option-id]') === container &&
        !['file', 'button', 'submit', 'reset'].includes(control.type) &&
        control.dataset.smoofDesignFilePicker !== 'true'
      );
  }

  function isProductConfigurationOption(container) {
    return editableControls(container).some(control =>
      PRODUCT_OPTION_INDEXES.has(String(control.dataset.optionIndex || ''))
    );
  }

  function captureProductConfiguration() {
    return Array.from(PRODUCT_OPTION_INDEXES).map(index => {
      const controls = Array.from(document.querySelectorAll(
        `main input[type="radio"][data-option-index="${index}"]`
      ));
      const checked = controls.find(control => control.checked);
      return {
        index,
        value: checked?.value || '',
        dataKey: checked ? controlDataKey(checked) : '',
        ordinal: checked ? controls.indexOf(checked) : -1
      };
    });
  }

  function restoreProductConfiguration(configuration) {
    (Array.isArray(configuration) ? configuration : []).forEach(saved => {
      const controls = Array.from(document.querySelectorAll(
        `main input[type="radio"][data-option-index="${saved.index}"]`
      ));
      if (!controls.length || controls.some(control => control.checked && (
        control.value === saved.value ||
        (saved.dataKey && controlDataKey(control) === saved.dataKey) ||
        controls.indexOf(control) === saved.ordinal
      ))) return;
      const target = controls.find(control => saved.dataKey && controlDataKey(control) === saved.dataKey) ||
        controls.find(control => control.value === saved.value) ||
        controls[Number(saved.ordinal)] || null;
      if (target && !target.checked) target.click();
    });
  }

  function controlDataKey(control) {
    return control.dataset.optionValueId ||
      control.dataset.valueId ||
      control.dataset.optionValue ||
      control.getAttribute('aria-label') ||
      '';
  }

  function captureOptions() {
    const options = {};
    const seen = new Set();
    document.querySelectorAll('[data-option-id]').forEach(option => {
      const id = option.dataset.optionId;
      if (!id || seen.has(id)) return;
      seen.add(id);
      if (isProductConfigurationOption(option)) return;
      const controls = editableControls(option);
      options[id] = controls.map(control => {
        const tag = control.tagName.toLowerCase();
        const type = control.type || '';
        const peers = controls.filter(candidate =>
          candidate.tagName.toLowerCase() === tag && (candidate.type || '') === type
        );
        return {
          tag,
          type,
          name: control.name || '',
          id: control.id || '',
          dataKey: controlDataKey(control),
          ordinal: peers.indexOf(control),
          value: control.value,
          checked: control instanceof HTMLInputElement && /^(radio|checkbox)$/.test(control.type)
            ? control.checked
            : undefined
        };
      });
    });
    return options;
  }

  function fontOptionRoot() {
    const candidates = Array.from(document.querySelectorAll(`[data-option-id="${FONT_OPTION_ID}"]`));
    return candidates.find(candidate => candidate.offsetParent !== null) || candidates[0] || null;
  }

  function normalizeFontFamily(value) {
    return String(value || '')
      .replace(/^["']|["']$/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100);
  }

  function captureFontFamily() {
    const option = fontOptionRoot();
    const value = option?.querySelector('select')?.value ||
      option?.querySelector('input[type="hidden"]')?.value ||
      option?.querySelector('button[aria-haspopup="listbox"]')?.innerText ||
      document.querySelector('[data-smoof-text-content]')?.style.fontFamily?.split(',')[0] ||
      '';
    return normalizeFontFamily(value);
  }

  function ensureGoogleFont(family) {
    const clean = normalizeFontFamily(family);
    if (!clean || !/^[a-z0-9 ._-]+$/i.test(clean)) return false;
    if (window.SmoofCustomFontRegistry?.isCustomFamily?.(clean)) {
      window.SmoofCustomFontRegistry.ensureLoaded(clean).then(() => {
        window.SmoofDesignRenderer?.scheduleRender?.();
        window.dispatchEvent(new CustomEvent('smoof:font-restored', { detail: { family: clean, custom: true } }));
      });
      return true;
    }
    const key = clean.toLowerCase();
    let link = Array.from(document.querySelectorAll('link[data-smoof-design-google-font]'))
      .find(candidate => candidate.dataset.smoofDesignGoogleFont === key);
    if (!link) {
      link = document.createElement('link');
      link.rel = 'stylesheet';
      link.dataset.smoofDesignGoogleFont = key;
      const encoded = encodeURIComponent(clean).replace(/%20/g, '+');
      link.href = `https://fonts.googleapis.com/css2?family=${encoded}:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap`;
      document.head.appendChild(link);
    }
    const notifyReady = () => {
      [300, 400, 700].forEach(weight => {
        document.fonts?.load?.(`${weight} 16px "${clean}"`);
        document.fonts?.load?.(`italic ${weight} 16px "${clean}"`);
      });
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:font-restored', { detail: { family: clean } }));
    };
    if (link.sheet) notifyReady();
    else link.addEventListener('load', notifyReady, { once: true });
    return true;
  }

  function applyFontFamily(family) {
    const clean = normalizeFontFamily(family);
    if (!clean) return false;
    const option = fontOptionRoot();
    if (!option) return false;
    const select = option.querySelector('select');
    let control = select || option.querySelector('input[type="hidden"]');
    if (select) {
      const match = Array.from(select.options).find(item =>
        normalizeFontFamily(item.value).toLowerCase() === clean.toLowerCase() ||
        normalizeFontFamily(item.textContent).toLowerCase() === clean.toLowerCase()
      );
      if (match) nativeValue(select, match.value);
      else {
        const restoredOption = document.createElement('option');
        restoredOption.value = clean;
        restoredOption.textContent = clean;
        restoredOption.dataset.smoofRestoredFontOption = 'true';
        select.appendChild(restoredOption);
        nativeValue(select, clean);
      }
    } else {
      if (!control) {
        control = document.createElement('input');
        control.type = 'hidden';
        control.dataset.smoofDesignFontValue = 'true';
        option.appendChild(control);
      }
      nativeValue(control, clean);
    }
    notifyControl(control);
    option.dataset.smoofRestoredFontFamily = clean;
    ensureGoogleFont(clean);
    window.dispatchEvent(new CustomEvent('smoof:font-selected', { detail: { family: clean, restored: true } }));
    return true;
  }

  function applyOptions(savedOptions) {
    Object.entries(savedOptions || {}).forEach(([id, savedControls]) => {
      const candidates = Array.from(document.querySelectorAll(`[data-option-id="${CSS.escape(id)}"]`));
      const option = candidates.find(candidate => candidate.offsetParent !== null) || candidates[0];
      if (!option || !Array.isArray(savedControls)) return;
      if (isProductConfigurationOption(option)) return;
      const controls = editableControls(option);
      savedControls.forEach(saved => {
        const matchingType = controls.filter(candidate =>
          candidate.tagName.toLowerCase() === saved.tag &&
          (candidate.type || '') === (saved.type || '')
        );
        let control = null;
        if (/^(radio|checkbox)$/.test(saved.type)) {
          control = matchingType.find(candidate =>
            candidate instanceof HTMLInputElement &&
            candidate.value === saved.value
          ) || null;
        } else {
          if (saved.name) control = matchingType.find(candidate => candidate.name === saved.name) || null;
          if (!control && saved.id) control = matchingType.find(candidate => candidate.id === saved.id) || null;
          if (!control && saved.dataKey) {
            control = matchingType.find(candidate => controlDataKey(candidate) === saved.dataKey) || null;
          }
          if (!control) control = matchingType[Number(saved.ordinal) || 0] || null;
        }
        if (!control) return;
        if (/^(radio|checkbox)$/.test(saved.type)) nativeChecked(control, Boolean(saved.checked));
        else nativeValue(control, String(saved.value ?? ''));
        notifyControl(control);
      });
    });
  }

  function captureProperties() {
    const properties = {};
    (productForm() || document).querySelectorAll('input[name^="properties[_SMOOF"]').forEach(input => {
      if (input.name === 'properties[_SMOOF Design State]') return;
      if (PRODUCT_CONFIGURATION_PROPERTIES.has(input.name)) return;
      if (input.type === 'file') return;
      properties[input.name] = input.value;
    });
    return properties;
  }

  function applyProperties(properties) {
    const form = productForm();
    if (!form) return;
    Object.entries(properties || {}).forEach(([name, value]) => {
      if (!/^properties\[_SMOOF [^\]]+\]$/.test(name)) return;
      if (PRODUCT_CONFIGURATION_PROPERTIES.has(name)) return;
      const matchingInputs = Array.from(form.querySelectorAll('input')).filter(candidate => candidate.name === name);
      if (matchingInputs.some(candidate => candidate.type === 'file')) return;
      let input = matchingInputs[0] || null;
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.dataset.smoofDesignFileProperty = 'true';
        form.appendChild(input);
      }
      nativeValue(input, String(value ?? ''));
      notifyControl(input);
    });
  }

  function captureSnapshot() {
    const bridgeBackground = window.SmoofBackgroundImageBridge?.getState?.();
    const toolBackground = window.SmoofBackgroundImageTools?.getState?.();
    return {
      options: captureOptions(),
      properties: captureProperties(),
      fontFamily: captureFontFamily(),
      textLayout: window.SmoofTextTools?.getHistoryState?.() || null,
      customTexts: window.SmoofCustomTextTools?.getHistoryState?.() || null,
      textVisibility: window.SmoofTextVisibility
        ? [0, 1, 2].map(index => window.SmoofTextVisibility.isVisible(index) !== false)
        : null,
      logo: window.SmoofLogoHistory?.getState?.() || null,
      logoCopy: window.SmoofLogoCopyTools?.getHistoryState?.() || null,
      logoDuplicate: window.SmoofLogoDuplicateTools?.getHistoryState?.() || null,
      logoBackgrounds: window.SmoofLogoBackgroundTools?.getHistoryState?.() || null,
      logoInversion: window.SmoofLogoInvertTools?.getHistoryState?.() || null,
      backgroundImage: bridgeBackground?.hasImage ? bridgeBackground : toolBackground || bridgeBackground || null,
      backgroundGradient: window.SmoofBackgroundGradientTools?.getHistoryState?.() || null,
      number: window.SmoofNumberHistory?.getState?.() || null,
      branding: window.SmoofBrandTools?.getHistoryState?.() || window.SmoofBrandTools?.getState?.() || null,
      arrows: window.SmoofArrowTools?.getHistoryState?.() || null,
      payments: window.SmoofPaymentTools?.getHistoryState?.() || null,
      socialPlatforms: window.SmoofSocialPlatformTools?.getHistoryState?.() || null,
      nfc: window.SmoofNfcTools?.getHistoryState?.() || window.SmoofNfcTools?.getState?.() || null,
      qr: window.SmoofQrGeometryTools?.getHistoryState?.() || window.SmoofQrGeometryTools?.getState?.() || null,
      layerOpacity: window.SmoofLayerOpacityTools?.getHistoryState?.() || null
    };
  }

  function cleanForJson(value) {
    return JSON.parse(JSON.stringify(value, (key, item) => {
      if (typeof File !== 'undefined' && item instanceof File) return undefined;
      if (typeof Blob !== 'undefined' && item instanceof Blob) return undefined;
      return item;
    }));
  }

  function timestamp() {
    const date = new Date();
    const part = value => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${part(date.getMonth() + 1)}-${part(date.getDate())}-${part(date.getHours())}${part(date.getMinutes())}`;
  }

  function blobToDataUrl(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(String(reader.result || '')), { once: true });
      reader.addEventListener('error', () => reject(reader.error || new Error('Image could not be read')), { once: true });
      reader.readAsDataURL(blob);
    });
  }

  async function normalizedBackgroundState(saved) {
    await window.SmoofBackgroundImageBridge?.sync?.();
    const bridged = window.SmoofBackgroundImageBridge?.getState?.();
    const current = bridged?.hasImage ? bridged : saved;
    if (!current?.hasImage) return current || null;
    const source = String(current.dataUrl || current.src || current.url || '');
    if (IMAGE_DATA_URL.test(source)) return { ...current, dataUrl: source };
    if (!/^(blob:|https?:)/i.test(source)) {
      throw new Error(t('Das Hintergrundbild ist noch nicht vollständig geladen. Bitte kurz warten und erneut speichern.', 'The background image has not finished loading. Please wait briefly and save again.'));
    }
    const response = await fetch(source);
    if (!response.ok) throw new Error(t('Das Hintergrundbild konnte nicht gelesen werden.', 'The background image could not be read.'));
    const imageBlob = await response.blob();
    if (!/^image\//i.test(imageBlob.type)) {
      throw new Error(t('Die Hintergrunddatei ist kein unterstütztes Bild.', 'The background file is not a supported image.'));
    }
    return {
      ...current,
      hasImage: true,
      dataUrl: await blobToDataUrl(imageBlob),
      mimeType: imageBlob.type
    };
  }

  async function save() {
    try {
      const design = captureSnapshot();
      design.backgroundImage = await normalizedBackgroundState(design.backgroundImage);
      const payload = cleanForJson({
        format: FORMAT,
        version: VERSION,
        savedAt: new Date().toISOString(),
        product: {
          handle,
          variantId: productForm()?.querySelector('[name="id"]')?.value || '',
          diameterMm: window.SmoofProductVariant?.get?.()?.diameterMm || null
        },
        customFonts: window.SmoofCustomFontRegistry?.exportRecords?.() || [],
        design
      });
      const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `SMOOF-Design-${timestamp()}.smoofdesign`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      showStatus(t('Design-Datei gespeichert', 'Design file saved'));
      window.dispatchEvent(new CustomEvent('smoof:design-file-saved', { detail: { payload } }));
      return payload;
    } catch (error) {
      showStatus(error.message || t('Das Design konnte nicht gespeichert werden.', 'The design could not be saved.'), true);
      return false;
    }
  }

  function validateImageState(state, label) {
    if (!state) return;
    const source = String(state.dataUrl || state.src || '');
    if (!source) return;
    if (!IMAGE_DATA_URL.test(source)) throw new Error(t(`${label}: nicht unterstützte Bilddaten.`, `${label}: unsupported image data.`));
    if (source.length > MAX_FILE_BYTES) throw new Error(t(`${label}: Bilddatei zu groß.`, `${label}: image too large.`));
  }

  function validate(payload) {
    if (!payload || payload.format !== FORMAT) throw new Error(t('Keine gültige SMOOF-Designdatei.', 'Not a valid SMOOF design file.'));
    if (!SUPPORTED_VERSIONS.has(Number(payload.version))) throw new Error(t('Diese Dateiversion wird noch nicht unterstützt.', 'This file version is not supported.'));
    if (!payload.design || typeof payload.design !== 'object') throw new Error(t('Die Designdaten fehlen.', 'The design data is missing.'));
    if (payload.product?.handle && payload.product.handle !== handle) throw new Error(t('Die Datei gehört zu einem anderen Produkt.', 'The file belongs to another product.'));
    validateImageState(payload.design.logo, 'Logo');
    validateImageState(payload.design.logoDuplicate, 'Logo 2');
    validateImageState(payload.design.backgroundImage, 'Background');
    if (payload.design.fontFamily && !/^[a-z0-9 ._-]{1,100}$/i.test(payload.design.fontFamily)) {
      throw new Error(t('Der gespeicherte Schriftname ist ungültig.', 'The saved font name is invalid.'));
    }
    if (Number(payload.version) >= 2 && !Array.isArray(payload.customFonts)) {
      throw new Error(t('Die eingebetteten Schriftdaten sind ungültig.', 'The embedded font data is invalid.'));
    }
    (payload.customFonts || []).forEach(item => {
      if (!item || typeof item !== 'object' || !/^cf-[0-9a-f]{24}$/.test(String(item.id || ''))) {
        throw new Error(t('Ein eingebetteter Fontdatensatz ist ungültig.', 'An embedded font record is invalid.'));
      }
      if (!/^data:font\/(?:ttf|otf|sfnt|truetype|opentype);base64,/i.test(String(item.dataUrl || ''))) {
        throw new Error(t('Eine eingebettete Schrift enthält ungültige Daten.', 'An embedded font contains invalid data.'));
      }
      if (String(item.dataUrl).length > (4 * 1024 * 1024 + 4096)) {
        throw new Error(t('Eine eingebettete Schrift ist zu groß.', 'An embedded font is too large.'));
      }
    });
    return payload;
  }

  function dataUrlFile(dataUrl, fileName) {
    const comma = dataUrl.indexOf(',');
    if (comma < 0) return null;
    const header = dataUrl.slice(0, comma);
    const mime = header.match(/^data:([^;,]+)/i)?.[1] || 'image/png';
    const encoded = dataUrl.slice(comma + 1);
    const bytes = /;base64/i.test(header)
      ? Uint8Array.from(atob(encoded), character => character.charCodeAt(0))
      : new TextEncoder().encode(decodeURIComponent(encoded));
    return new File([bytes], fileName || 'background.png', { type: mime });
  }

  function backgroundFileInput() {
    const bridged = window.SmoofBackgroundImageBridge?.input?.();
    if (bridged) return bridged;
    const direct = document.querySelector([
      '[data-smoof-background-file-input]',
      '[data-smoof-background-upload] input[type="file"]',
      'input[type="file"][name*="Hintergrund"]',
      'input[type="file"][name*="background" i]'
    ].join(','));
    return direct || null;
  }

  async function applyBackgroundImage(saved) {
    const bridge = window.SmoofBackgroundImageBridge;
    if (typeof bridge?.applyState === 'function') {
      const restored = await bridge.applyState(saved);
      if (restored !== false) return true;
    }
    const tools = window.SmoofBackgroundImageTools;
    if (!saved?.hasImage || !saved.dataUrl) {
      tools?.remove?.();
      return true;
    }
    for (const method of ['applyHistoryState', 'applyState', 'restoreState', 'setState']) {
      if (typeof tools?.[method] === 'function') {
        const result = await tools[method](saved);
        if (result !== false) return true;
      }
    }
    const input = backgroundFileInput();
    const file = dataUrlFile(saved.dataUrl, saved.fileName || 'background.png');
    if (!input || !file || typeof DataTransfer !== 'function') return false;
    try {
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      notifyControl(input);
      return true;
    } catch (error) {
      return false;
    }
  }

  function applyTextVisibility(saved) {
    (Array.isArray(saved) ? saved : []).forEach((visible, index) => {
      if (!window.SmoofTextVisibility) return;
      if (window.SmoofTextVisibility.isVisible(index) !== Boolean(visible)) {
        window.SmoofTextVisibility.toggle(index);
      }
    });
  }

  function applyToolStates(design) {
    if (design.fontFamily) applyFontFamily(design.fontFamily);
    if (design.textLayout) window.SmoofTextTools?.applyHistoryState?.(design.textLayout);
    if (design.customTexts) window.SmoofCustomTextTools?.applyHistoryState?.(design.customTexts);
    if (design.logo) window.SmoofLogoHistory?.applyState?.(design.logo);
    if (design.logoCopy) window.SmoofLogoCopyTools?.applyHistoryState?.(design.logoCopy);
    if (design.logoDuplicate) window.SmoofLogoDuplicateTools?.applyHistoryState?.(design.logoDuplicate);
    if (design.logoBackgrounds) window.SmoofLogoBackgroundTools?.applyHistoryState?.(design.logoBackgrounds);
    if (design.logoInversion) window.SmoofLogoInvertTools?.applyHistoryState?.(design.logoInversion);
    if (design.backgroundGradient) window.SmoofBackgroundGradientTools?.applyHistoryState?.(design.backgroundGradient);
    if (design.number) window.SmoofNumberHistory?.applyState?.(design.number);
    if (design.branding) (window.SmoofBrandTools?.applyHistoryState || window.SmoofBrandTools?.applyState)?.call(window.SmoofBrandTools, design.branding);
    if (design.arrows) window.SmoofArrowTools?.applyHistoryState?.(design.arrows);
    if (design.payments) window.SmoofPaymentTools?.applyHistoryState?.(design.payments);
    if (design.socialPlatforms) window.SmoofSocialPlatformTools?.applyHistoryState?.(design.socialPlatforms);
    if (design.nfc) (window.SmoofNfcTools?.applyHistoryState || window.SmoofNfcTools?.applyState)?.call(window.SmoofNfcTools, design.nfc);
    if (design.qr) window.SmoofQrGeometryTools?.applyHistoryState?.(design.qr);
    if (design.layerOpacity) window.SmoofLayerOpacityTools?.applyHistoryState?.(design.layerOpacity);
    applyTextVisibility(design.textVisibility);
  }

  async function restore(payload, { confirmReplace = true } = {}) {
    validate(payload);
    if (confirmReplace && !window.confirm(t('Das aktuelle Design wird ersetzt. Möchten Sie die Datei wirklich öffnen?', 'The current design will be replaced. Do you want to open this file?'))) {
      return false;
    }
    if ((payload.customFonts || []).length) {
      if (!window.SmoofCustomFontRegistry?.importRecords) {
        throw new Error(t('Die Verwaltung eigener Schriften ist noch nicht geladen. Bitte die Seite neu laden.', 'Custom-font support is not loaded yet. Please reload the page.'));
      }
      await window.SmoofCustomFontRegistry.importRecords(payload.customFonts);
    }
    const design = payload.design;
    const productConfiguration = captureProductConfiguration();
    applyOptions(design.options);
    applyProperties(design.properties);
    applyToolStates(design);
    const backgroundRestored = await applyBackgroundImage(design.backgroundImage);
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    applyOptions(design.options);
    applyProperties(design.properties);
    applyToolStates(design);
    restoreProductConfiguration(productConfiguration);
    setTimeout(() => {
      applyToolStates(design);
      restoreProductConfiguration(productConfiguration);
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:design-file-loaded', { detail: { payload } }));
    }, 260);
    if (design.backgroundImage?.hasImage && !backgroundRestored) {
      throw new Error(t('Das Hintergrundbild konnte nicht wiederhergestellt werden.', 'The background image could not be restored.'));
    }
    showStatus(t('Design erfolgreich geöffnet', 'Design opened successfully'));
    return true;
  }

  async function readFile(file) {
    if (!file) return false;
    if (file.size > MAX_FILE_BYTES) throw new Error(t('Die Datei ist zu groß.', 'The file is too large.'));
    const payload = JSON.parse(await file.text());
    return restore(payload);
  }

  function ensurePicker() {
    if (picker?.isConnected) return picker;
    picker = document.createElement('input');
    picker.type = 'file';
    picker.accept = '.smoofdesign,application/json';
    picker.hidden = true;
    picker.dataset.smoofDesignFilePicker = 'true';
    picker.addEventListener('change', async () => {
      const file = picker.files?.[0];
      try {
        await readFile(file);
      } catch (error) {
        showStatus(error.message || t('Die Datei konnte nicht geöffnet werden.', 'The file could not be opened.'), true);
      } finally {
        picker.value = '';
      }
    });
    document.body.appendChild(picker);
    return picker;
  }

  function open() {
    ensurePicker().click();
  }

  window.SmoofDesignFileTools = Object.freeze({
    format: FORMAT,
    version: VERSION,
    save,
    open,
    readFile,
    restore,
    capture: () => cleanForJson(captureSnapshot())
  });
  ensurePicker();
})();
